import type { ItemMetaData } from '@mimir/common/dto/fieldValue';
import type { ClientItem } from '@mimir/common/dto/searchResultHit';
import type { MetaDataSchema } from '@mimir/common/mdf/metadataSchema';
import { replaceIdWithFieldIdForSchemasAndFillDefaultValues } from '@mimir/common/mdf/MetaDataForm';
import { getGlobalStore } from '@mimir/web/store/';
import { getFieldDefinitionsForMetadata } from '@mimir/common/mdf/subtype';

/**
 * Send a message to parent frame. Used in Vimond IO export workflow.
 * @param item The item to pick data from
 */
export const sendSelectedEvent = async (item: Partial<ClientItem> | null) => {
  let message;
  if (item === null) {
    message = {
      action: 'deselected'
    };
  } else if (!item.metadata) {
    message = {
      action: 'selected',
      payload: {
        id: item.id,
      }
    };
  } else {
    message = {
      action: 'selected',
      payload: {
        id: item.id,
        metadata: replaceIds(item.metadata)
      }
    };
  }

  window.parent.postMessage(message, '*');
};

/**
 * Return a copy with all GUIDs replaced with their corresponding field id
 */
export const replaceIds = (metadata: ItemMetaData): ItemMetaData => {
  const allSchemas = getGlobalStore().getters.mdfs  as MetaDataSchema[] | undefined;
  if (!allSchemas) {
    // Shouldn't happen, but let's not crash out.
    return metadata;
  }

  const { fieldMap } = getFieldDefinitionsForMetadata(metadata, allSchemas);
  const clone = replaceIdWithFieldIdForSchemasAndFillDefaultValues(metadata, Object.values(fieldMap));
  return clone;
};
